'use client';
import { useI18n } from '@/components/public/i18n/LocaleProvider';
import type { UniverseId } from '@/lib/public/universes';
import { HERO_IMAGES as SOURCE_HERO_IMAGES } from '@/lib/public/universe-visuals';

export default function UniverseVisual({ id }: { id: UniverseId }) {
  const { t, href, content, locale } = useI18n();
  const HERO_IMAGES = content(SOURCE_HERO_IMAGES);

  const visual = HERO_IMAGES[id];
  return (
    <div className={`u-hero-photo u-hero-photo-${id}`}>
      <img src={visual.src} alt={visual.alt} fetchPriority="high" decoding="async" />
      <div className="u-photo-caption">
        <span className="u-live-dot" />
        <span>{visual.caption}</span>
      </div>
    </div>
  );
}


